<div class="main">
  <header-menu></header-menu>

  <div class="profile-content">
    <ng-core-loading *ngIf="(loadingMgmConfig$ | async) || (vouchersLoading$ | async)"></ng-core-loading>

    <div *ngIf="!(loadingMgmConfig$ | async) && !(vouchersLoading$ | async)" class="fade-in-animation">
      <invitation-banner
        [title]="'Indique Allya'"
        [subtitle]="'Amigo é coisa para se indicar!'"
      >
        <p *ngIf="(voucherIsActive$ | async)">Ganhe um voucher de R$ {{(voucherProvider$ | async)?.amount}} para gastar no {{(voucherProvider$ | async)?.name}}, indicando pessoas que trabalham com você!</p>
        <p *ngIf="!(voucherIsActive$ | async)">Compartilhe a experiência de economizar com Allya, indicando pessoas que trabalham com você.</p>
      </invitation-banner>

      <div class="cards-row">
        <invitation-link
          [loading]="(loadingMgmConfig$ | async)"
          [link]="getLink(inviteMemberCode$ | async)"
          [voucherActive]="voucherIsActive$ | async"
          [voucherProvider]="voucherProvider$ | async"
        >
        </invitation-link>
      </div>

      <div class="cards-row">
        <invitation-vouchers
          class="card-item"
          *ngIf="(voucherIsActive$ | async)"
          [loading]="(vouchersLoading$ | async) || (loadingMgmConfig$ | async)"
          [invites]="invites$ | async"
          [vouchers]="vouchers$ | async"
          [voucherProvider]="voucherProvider$ | async">
        </invitation-vouchers>

        <invitation-accepted
          class="card-item"
          [ngClass]="{'without-voucher': !(voucherIsActive$ | async)}"
          [loading]="(loadingMgmConfig$ | async)"
          [invites]="invites$ | async"
          [limit]="3">
        </invitation-accepted>
      </div>

      <div class="how-it-works">
        <div class="hiw-title">Veja como funciona:</div>

        <div class="hiw-list">
          <div class="hiw-item">
            <img src="../../../../assets/shared/img/icon-how-it-works-01.svg" alt="Como funciona">
            <span>Você copia o link e compartilha com pessoas que trabalham com você.</span>
          </div>

          <div class="hiw-item">
            <img src="../../../../assets/shared/img/icon-how-it-works-02.svg" alt="Como funciona">
            <span *ngIf="(voucherIsActive$ | async)">Seu amigo se cadastra através do link que você enviou e ganha R$ {{(voucherProvider$ | async)?.amount}} para gastar no {{(voucherProvider$ | async)?.name}}.</span>
            <span *ngIf="!(voucherIsActive$ | async)">Seu amigo se cadastra através do link que você enviou.</span>
          </div>

          <div class="hiw-item">
            <img src="../../../../assets/shared/img/icon-how-it-works-03.svg" alt="Como funciona">
            <span *ngIf="(voucherIsActive$ | async)">A cada 3 pessoas cadastradas, você também ganha R$ {{(voucherProvider$ | async)?.amount}} para gastar como quiser no {{(voucherProvider$ | async)?.name}}.</span>
            <span *ngIf="!(voucherIsActive$ | async)">Agora você e seus indicados podem compartilhar da experiência de economizar com Allya</span>
          </div>
        </div>

        <button routerLink="conheca-as-regras" *ngIf="(voucherIsActive$ | async)" class="btn btn-rules">Conheça as regras</button>
      </div>
    </div>
  </div>
</div>
